export const windows = require("./Microsoft_Badge.svg");
export const apple = require("./App_Store_Badge.svg");
export const google = require("./Google_Play_Badge.svg");
export const linux = require("./Linux_Badge.svg");
